import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentPage } from 'selectors/location'
import AutomateMenu, { sectionPages } from './Menu'
import ButtonWithMenu from '../ButtonWithMenu'

const AutomateSection = ({ className, active }) => {
  const [open, setOpen] = useState(false)
  const isActive =
    Object.values(sectionPages).includes(useSelector(selectCurrentPage)) ||
    active === 'Knowledge Base'

  const handleCloseMenu = useCallback(() => {
    setOpen(false)
  }, [])
  return (
    <ButtonWithMenu
      css={className}
      isActive={isActive}
      open={open}
      setOpen={setOpen}
      overlay={<AutomateMenu onClose={handleCloseMenu} />}
    >
      Automate
    </ButtonWithMenu>
  )
}

export default AutomateSection
